import { render, staticRenderFns } from "./BankDetailsAddEditModal.vue?vue&type=template&id=9e690eb0"
import script from "./BankDetailsAddEditModal.vue?vue&type=script&lang=js"
export * from "./BankDetailsAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports